import Repository from '@/api/core'
import queryString from 'query-string'
import vendor from '@/store/modules/vendor'
const baseURL = process.env.VUE_APP_API_LEARN + '/course'

const count = params => {
	const query = queryString.stringify({
		...params,
		vendorId: vendor.state.vendor.vendorId
	})
	return Repository(baseURL + '/count' + `?${query}`).fetch()
}

const fetch = params => {
	const query = queryString.stringify({
		...params,
		vendorId: vendor.state.vendor.vendorId
	})
	return Repository(baseURL + `?${query}`).fetch()
}

const search = params => {
	const query = queryString.stringify({
		...params,
		vendorId: vendor.state.vendor.vendorId
	})
	return Repository(
		process.env.VUE_APP_API_LEARN + '/search' + `?${query}`
	).fetch()
}

const fetchOne = id => {
	return Repository(baseURL).fetchOne(id)
}

const create = params => {
	return Repository(baseURL).create(params)
}

const update = (id, params) => {
	return Repository(baseURL).update(id, params)
}

const remove = id => {
	return Repository(baseURL).delete(id)
}

const statistic = params => {
	return Repository(baseURL + '/statistic').fetch(params)
}
const getLiveCourse = params => {
	return Repository(baseURL + '/live-course').fetch(params)
}
const countLiveCourse = params => {
	const query = queryString.stringify({
		...params,
		vendorId: vendor.state.vendor.vendorId
	})
	return Repository(baseURL + '/live-course/count' + `?${query}`).fetch()
}
const retryLiveCourse = params => {
	return Repository(`${baseURL}/retry-live-course`).create(params)
}
export default {
	count,
	fetch,
	fetchOne,
	create,
	update,
	remove,
	search,
	statistic,
	getLiveCourse,
	countLiveCourse,
	retryLiveCourse
}
